import { APRType } from '../../context';

export const FINANCE_ORDER: APRType[] = [
  'INTEREST_FREE',
  'INTEREST_BEARING',
  'BUYNOW_PAYLATER',
];
